module.exports = __webpack_public_path__ + "static/media/WindowsProvisioningPlatform.0944ee4c.png";